import styled from '@emotion/styled';
import ChevronDown from '@assets/svg/chevron-down.svg';
import {colors} from '@styles/colors';

export const DropdownInput = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  min-width: 120px;
  min-height: 30px;
  cursor: pointer;

  input,
  [data-input='true'] {
    font-size: 12px;
    padding-right: 15px;
    display: block;
  }

  > div:first-of-type {
    width: 100%;
    height: 100%;
  }
`;

export const DownArrow = styled(ChevronDown)<{ open: boolean }>`
  position: absolute;
  fill: ${colors.mainTextColor};
  width: 8px;
  right: 15px;
  top: 9px;
  transform-origin: center center;
  transform: rotate(${(props) => (props.open ? 180 : 0)}deg);
  transition: transform 0.2s;
  pointer-events: none;
`;
